import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "addPictureFilled"
const AddPictureFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.125 13.125V17.063H22.875V18.938H19.125V22.875H17.25V18.938H13.125V17.063H17.25V13.125z" />
          <path
            fillRule="evenodd"
            d="M18 1.5C18.828 1.5 19.5 2.172 19.5 3V11.625H15.75V14.1C15.523 14.258 15.33 14.414 15.174 14.55 15.397 14.851 15.586 15.151 15.75 15.442V15.562H14.056Q13.853 15.276 13.6 14.984C12.088 13.244 9.071 11.4 3 11.26V18H11.625V19.5H3C2.172 19.5 1.5 18.828 1.5 18V3C1.5 2.172 2.172 1.5 3 1.5zM13.875 4.5C12.425 4.5 11.25 5.675 11.25 7.125S12.425 9.75 13.875 9.75 16.5 8.575 16.5 7.125 15.325 4.5 13.875 4.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AddPictureFilledIcon
